import Component from './Component';
import React from 'react';
import {Button, DropdownButton, MenuItem, ButtonToolbar} from 'react-bootstrap';
import {LoadingButton} from 'reactis-loader';
import ActionButton from './ActionButton';

export default class BtnToolbar extends Component {

	handleClick(e) {
		e.preventDefault();
		if (this.props.onClick) {
			this.props.onClick();
		}
	}

	render() {

		const buttons = this.props.buttons.filter((item) => item.visible || typeof item.visible == 'undefined').map((item, index) => {
			if (item.divider) {
				return false;
			}
			return	<LoadingButton
						key={index}
						disabled={item.disabled}
						className="hidden-xs"
						bsStyle={item.bsStyle}
						icon={item.icon}
						title={item.title}
						loading={item.loading}
						onClick={item.onClick}
					/>
		});

		const mainButton = <LoadingButton
			disabled={this.props.buttons[0].disabled}
			bsStyle={this.props.buttons[0].bsStyle}
			icon={this.props.buttons[0].icon}
			title={this.props.buttons[0].title}
			loading={this.props.buttons[0].loading}
			onClick={this.props.buttons[0].onClick}
		/>;

		const moreButton = this.props.buttons.filter((item, index) => index > 0 && (item.visible || typeof item.visible == 'undefined'))
							.map((item, index) => {
								if (item.divider) {
									return <MenuItem divider key={index} />;
								}
								return	<MenuItem key={index} eventKey={index} onClick={item.onClick}>
											<i style={{color:item.color}} className={item.icon + ' position-left'}></i>{item.title}
										</MenuItem>
		});

		const c = this.props.buttons.filter((item) => item.visible).length;

		return (
			<div>
				<ButtonToolbar className="hidden-xs">
					{buttons}
				</ButtonToolbar>
				{c > 1 &&
				<ButtonToolbar className="visible-xs">
					{mainButton}
					<DropdownButton pullRight bsStyle="default" title={<span><i className="fa fa-ellipsis-v position-left"></i>Další volby</span>} id="more">
						{moreButton}
					</DropdownButton>
				</ButtonToolbar>}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/ButtonToolbar.js